import React from "react";
import EditSquareIcon from "../../../shared/components/icons/EditSquareIcon";
import HighDensityIcon from "../../../shared/components/icons/HighDensityIcon";

import { Box } from "../../../shared/components/ui/chakra";
import { Flex, HStack } from "@chakra-ui/react";

const StickyFooter = ({ onDraft, onPreview, }: { onDraft: () => void, onPreview: () => void }) => {
  return (
    <Flex
      pt={4}
      pb={{ base: 8, md: 4 }}
      px={6}
      bgColor="rgba(60, 170, 145, 0.4)"
      alignItems="center"
      justifyContent={{ base: "center", md: "space-between" }}
      flexDir={{ base: "column-reverse", md: "row" }}
      backdropFilter="blur(20px)"
    >
      <Box as="button" bgColor="white" py={2.5} pl={3} pr={4} onClick={onDraft}>
        <HStack gap={2}>
          <EditSquareIcon />
          <Box mt={0.5}>
            <Box
              fontSize="sm"
              fontWeight="bold"
              color="primary"
              textAlign="left"
            >
              下書き保存
            </Box>
            <Box fontSize="xs" color="textGray">
              事業者情報・詳細情報がまとめて保存されます
            </Box>
          </Box>
        </HStack>
      </Box>
      <Box as="button" pl={2} pr={3} py={2} onClick={onPreview}>
        <HStack gap={1}>
          <Box>
            <HighDensityIcon />
          </Box>
          <Box fontWeight="bold" color="textLink" mt={0.5}>
            プレビュー表示
          </Box>
        </HStack>
      </Box>
    </Flex>
  );
};

export default StickyFooter;
